import * as React from 'react';
import { FormLayoutRow } from '../form-layout-row/form-layout-row';
import { CloseCircleOutlined } from '@ant-design/icons';
import { secondsToMinutes } from '../../utils';
export function friendlyThrottleDisplay(domain) {
  if (!domain || !domain.deliveryThrottleMaxSeconds) {
    return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(CloseCircleOutlined, null), " None");
  }
  var throttleValue = domain.deliveryThrottleMaxSeconds;
  var convertedValue = secondsToMinutes(throttleValue);
  return "Notification sends should be spread over ".concat(convertedValue, " minutes.");
}
export var DeliveryThrottlingDisplay = function DeliveryThrottlingDisplay(_ref) {
  var domain = _ref.domain;
  return /*#__PURE__*/React.createElement("div", {
    className: "notification-delivery-throttling-display"
  }, /*#__PURE__*/React.createElement(FormLayoutRow, {
    label: "Delivery Throttle",
    value: friendlyThrottleDisplay(domain)
  }));
};